module.exports = __webpack_public_path__ + "static/media/Adaptable.6c672e7f.png";